import React from 'react';
import { Row, Col, Card, Typography, Space } from 'antd';
import ByLeadersBarChart from '../../graphics/byLeadersBarChart';
import { formatVisiblePercent } from '../selfcare360/selfcare360Scales';

const { Text, Title } = Typography;

const LeadershipByDimensions = ({
    strengths = [],
    gaps = [],
    chartData = [],
    redLight,
    yellowLight,
    serviceId,
    showCards = false
}) => {
    const renderList = (items, emptyMessage) => {
        if (items.length === 0) {
            return (
                <Text style={{ fontSize: '11px' }}>
                    {emptyMessage}
                </Text>
            );
        }

        return (
            <ul style={{ paddingLeft: 20, marginBottom: 0, marginTop: 0 }}>
                {items.map((item, index) => (
                    <li key={index}>
                        <Text style={{ fontSize: '11px' }}>
                            {item.question} – <strong>{formatVisiblePercent(item.average)}</strong>
                        </Text>
                    </li>
                ))}
            </ul>
        );
    };

    return (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
            {showCards && (
                <Row gutter={[16, 16]} align="stretch">
                    <Col xs={24} md={24}>
                        {(strengths.length === 0 && gaps.length === 0) ? (
                            <Card bordered>
                                <Text style={{ fontSize: '14px', textAlign: 'justify' }}>
                                    Los resultados no arrojaron fortalezas ni brechas significativas para esta dimensión.
                                </Text>
                            </Card>
                        ) : (
                            <>
                                <Row gutter={16}>
                                    {/* Fortalezas */}
                                    <Col xs={24} md={24}>
                                        <Title level={5} style={{ color: "#43a047" }}>✅ Fortalezas</Title>
                                        <Card styles={{ body: { padding: 12 } }} style={{ backgroundColor: "#e8f5e9" }}>
                                            {renderList(strengths, 'No se identifican fortalezas en esta dimensión en la medición actual.')}
                                        </Card>
                                    </Col>
                                </Row>
                                <Row gutter={16}>
                                    {/* Brechas */}
                                    <Col xs={24} md={24}>
                                        <Title level={5} style={{ color: "#e53935" }}>❌ Brechas</Title>
                                        <Card styles={{ body: { padding: 12 } }} style={{ backgroundColor: "#ffebee" }}>
                                            {renderList(gaps, 'No se identifican brechas críticas en esta dimensión en la medición actual.')}
                                        </Card>
                                    </Col>
                                </Row>
                            </>
                        )}
                    </Col>
                </Row>
            )}

            {/* Gráfico */}
            <Row gutter={[16, 16]}>
                <Col xs={24}>
                    <div style={{ marginTop: 16 }}>
                        <ByLeadersBarChart
                            data={chartData}
                            redLight={redLight}
                            yellowLight={yellowLight}
                            serviceId={serviceId}
                        />
                    </div>
                </Col>
            </Row>
        </Space>
    );
};

export default LeadershipByDimensions;
